import React from 'react'
import ReactDOM from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import App from './App.tsx'
import './index.css'

const isDev = import.meta.env.DEV
const isProd = import.meta.env.PROD

const canUseServiceWorker = (() => {
  if (typeof window === 'undefined') return false
  if (!('serviceWorker' in navigator)) return false
  if (!isProd) return false
  if (window.isSecureContext) return true
  const host = window.location.hostname
  return host === 'localhost' || host === '127.0.0.1'
})()

async function cleanupDevServiceWorkers() {
  if (typeof window === 'undefined') return
  if (!('serviceWorker' in navigator)) return

  try {
    const registrations = await navigator.serviceWorker.getRegistrations()
    await Promise.all(registrations.map((registration) => registration.unregister()))
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Service worker cleanup failed:', error)
  }

  try {
    if (!('caches' in window)) return
    const cacheNames = await caches.keys()
    await Promise.all(
      cacheNames
        .filter((name) => name.startsWith('workbox-') || name.includes('precache') || name.includes('runtime'))
        .map((name) => caches.delete(name))
    )
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Cache cleanup failed:', error)
  }
}

if (isDev) {
  void cleanupDevServiceWorkers()
}

if (canUseServiceWorker) {
  try {
    // autoUpdate: new SW activates and reloads the page when a deploy is detected.
    // Also re-check on tab focus and periodically so long-lived sessions (e.g. kiosks) pick up updates.
    registerSW({
      immediate: true,
      onRegisteredSW(_swUrl, registration) {
        if (!registration) return

        const checkForUpdate = () => {
          void registration.update()
        }

        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') checkForUpdate()
        })

        window.setInterval(checkForUpdate, 5 * 60 * 1000)
      },
    })
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Service worker registration skipped:', error)
  }
} else {
  // eslint-disable-next-line no-console
  console.info(isProd ? 'Service worker disabled for non-secure origin' : 'Service worker disabled in development')
}

// Stale-cache boot failures are handled in index.html, which still runs when
// this module never loads. That shell reloads once, then shows the recovery page.

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
) 